import React from 'react'

type DashboardWidgetProps = {
    mainTitle:string,
    subTitle:string,
    cardClass:string,
    icon:string
}

const DashboardWidget = (props: DashboardWidgetProps) => {
    const {mainTitle,subTitle,cardClass,icon}=props;
  return (
    <div className={`dashboard-report-card ${cardClass}`}>
    <div className="card-content">
        <div className="card-content">
            <span className="card-title fs-6">{mainTitle}</span>
            <span className="card-sub-title fs-3">{subTitle}</span>
        </div>
        <div className="card-media">
            <i className={`fa-solid ${icon}`}></i>
        </div>
    </div>
</div>
  )
}

export default DashboardWidget